import { faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { SRL_CATEGORIES } from "../../constants";
import { X } from "react-feather";

const CategoryFilter = ({ selectedCategory, setSelectedCategory }) => {
  const [srlCategories] = useState(SRL_CATEGORIES);
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <React.Fragment>
      <Dropdown
        id={"dropdown-button-drop"}
        title={"Categoies"}
        onSelect={(e) => {
          setSelectedCategory(e);
        }}
        show={showDropdown}
        onToggle={(nextShow, meta) => {
          setShowDropdown(nextShow);
        }}
      >
        <Dropdown.Toggle
          as={"div"}
          bsPrefix={"ddt"}
          id="dropdown-autoclose-true"
          style={{ cursor: "pointer" }}
        >
          {selectedCategory ? (
            <div className="badge bg-primary p-1 ms-2 cursor-pointer">
              {selectedCategory}
              <X
                className="cursor-pointer ms-2"
                size={14}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedCategory(null);
                  setShowDropdown(false);
                }}
              />
            </div>
          ) : (
            <FontAwesomeIcon
              title={"SRL Product Category filter"}
              icon={faLayerGroup}
              size={"lg"}
              className="text-white bg-black mx-1"
              fixedWidth
            />
          )}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {srlCategories.map((categoryValue, categoryIndex) => {
            return (
              <Dropdown.Item key={categoryIndex} eventKey={categoryValue.name}>
                {categoryValue.name}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    </React.Fragment>
  );
};

export default CategoryFilter;
